import React from 'react';
import { OmniTooltipNextComponent } from './omni-components';

export class AccordionComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          displayAccordionContent : props.accordion.isOpen ? "block" : "none"
        }
    }

    openAccordion = () => {
        (this.state.displayAccordionContent === "none") ? (this.setState({ displayAccordionContent: "block" })) : (this.setState({ displayAccordionContent: "none" }));
    }

    render() {
        return (
          <div>
            <div className='accordionHeader' onClick={this.openAccordion}>
              {this.state.displayAccordionContent === 'none' && (
                <omni-icon className='is-size-1' icon-id='omni:interactive:up'></omni-icon>
              )}
              {this.state.displayAccordionContent === 'block' && (
                <omni-icon className='is-size-4' icon-id='omni:interactive:down'></omni-icon>
              )}
              {this.props.accordion.header}
              {this.props.accordion.tooltipMessage && (
                <div>
                    <OmniTooltipNextComponent>
                      <div slot='invoker' aria-haspopup='true'>
                        <omni-icon class='is-size-4 cursor infoIcon' icon-id='omni:informative:info'></omni-icon>
                      </div>
                      <div slot='content'>
                        {this.props.accordion.tooltipMessage}
                      </div>
                    </OmniTooltipNextComponent>
                </div>
              )}
            </div>

            <div style={{ display: this.state.displayAccordionContent }}>
              {this.props.accordion.content || this.props.children}
            </div>
          </div>
        );
    }
}